import React from 'react'

type ReactRef<T> = React.RefCallback<T> | React.RefObject<T> | null | undefined

export const mergeRefs =
  <T>(...refs: ReactRef<T>[]): React.RefCallback<T> =>
  (node) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(node)
      } else if (ref != null) {
        // Note: React's `RefObject<T>.current` is typed as exactly `T`, but a
        // callback ref always receives `T | null`. Object refs handed to a
        // ref-merging utility are, in practice, always mutable (created via
        // `useRef`), so this mirrors the standard `useComposedRefs` pattern.
        ;(ref as React.MutableRefObject<T | null>).current = node
      }
    }
  }
